interface IDimension {
  width: number;
  height: number;
}

export function computeInnerDimensions(element: HTMLElement): IDimension {
  if (element == null) {
    return { width: 100, height: 100 };
  }

  const style = getComputedStyle(element);
  const width = element.clientWidth - parseFloat(style.paddingLeft) - parseFloat(style.paddingRight);
  const height = element.clientHeight - parseFloat(style.paddingTop) - parseFloat(style.paddingBottom);

  return {
    height,
    width
  };
}
